class CartDrawerQuantityInput extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    // Query inner elements once they are parsed
    this.input = this.querySelector('input');
    this.plusButton = this.querySelector('[name="plus"]');
    this.minusButton = this.querySelector('[name="minus"]');

    if (this.plusButton) {
      this.plusButton.addEventListener('click', () => this.changeQuantity(1));
    }
    if (this.minusButton) {
      this.minusButton.addEventListener('click', () => this.changeQuantity(-1));
    }
  }
  changeQuantity(change) {
    const currentValue = parseInt(this.input.value, 10) || 0;
    const newValue = currentValue + change;

    // Use attribute values if provided
    const minAttr = this.input.getAttribute('min');
    const maxAttr = this.input.getAttribute('max');
    const min = minAttr !== null ? parseInt(minAttr, 10) : 0;
    const max = maxAttr !== null ? parseInt(maxAttr, 10) : Infinity;

    if (newValue >= min && newValue <= max) {
      this.input.value = newValue;
      // Dispatch a change event so that cart.js can update the cart
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

customElements.define('cart-drawer-quantity-input', CartDrawerQuantityInput);
